<div
  [class.dark-theme]="themeService.isDark()"
  [class.card-bordered-theme]="themeService.isCardBorder()"
  [class.card-border-radius]="themeService.isCardBorderRadius()"
  [class.rtl-enabled]="themeService.isRTLEnabled()"
>
  <app-loading-overlay></app-loading-overlay>
  <app-sidebar></app-sidebar>
  <div
    id="app-admin-shell"
    class="main-content d-flex flex-column"
    [ngClass]="{ active: isToggled }"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
  >
    <app-header></app-header>
    <!-- <app-breadcrumb></app-breadcrumb> -->

    <div id="router-outlet">
      <router-outlet></router-outlet>
      <!-- <app-footer></app-footer> -->
    </div>
    <!-- <div class="flex-grow-1"></div> -->
  </div>
  <app-customizer-settings></app-customizer-settings>
</div>
